export class DatePicked {
  start: Date;
  end: Date;

  constructor(s = null, e = null) {
    this.start = s;
    this.end = e;
  }
}
